import { connect } from "react-redux";

import ConvertersPool from "../Components/Converters/ConvertersPool";
import {
  addConverter,
  addNConverters,
  copyConverter,
  removeConverter,
  setConfigParam,
  setDraggedConverter,
} from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converters: state.converters,
    locale: state.locale,
    draggedConverter: state.draggedConverter,
    enableCRUD: state.enableCRUD,
  };
};

const mapDispatchToProps = {
  addConverter,
  addNConverters,
  copyConverter,
  removeConverter,
  setConfigParam,
  setDraggedConverter,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvertersPool);
